import React, { useEffect, useState } from "react";
import axios from "axios";
import $ from "jquery";
import Swal from "sweetalert2";


export function makeId(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function isNullOrUndefined(obj) {
  if (obj === null || obj === undefined) {
    return true;
  }
  return false;
}


export const RichBox = (props) => {
  const [id, setId] = useState (props.id ?? "000");// = makeId(5);
  const [froala, setFroala] = useState (null);
  const [CrTextEditor, setCrTextEditor] = useState(false)

  useEffect(() => {
    if (id == "000") {
      setId(makeId(10));
    }
    let w = window;
    if (w.CreateTextEditor === undefined || typeof w.CreateTextEditor !== 'function') {
      const GetFroala = async () => {
        Swal.showLoading();
        w.FROALA_BASE_LINK = "https://cloud.ivyis.org/front-end/";
        let resources = await axios.get("https://cloud.ivyis.org/front-end/froala/json.php");
        let head = document.getElementsByTagName("head")[0];
        resources.data.css.forEach((css) => {
          let style = document.createElement("link");
          style.rel = "stylesheet";
          style.href = css;
          head.appendChild(style);
        });
        w.scripts = resources.data.js.length;
        let index = 0;
        const onload = () => {
          if (index >= w.scripts) {
            let w = window;
            w.FROALA_BASE_LINK = "https://cloud.ivyis.org/front-end/";
            if (w.FroalaLoadHandlers === undefined) w.FroalaLoadHandlers = [];
            w.onFroalaLoaded = () => {
              if (w.FroalaLoadHandlers !== undefined) w.FroalaLoadHandlers.forEach((func) => func());
            }; w.CreateTextEditor = (e, maxChar = 9999999) => {
              return new FroalaEditor(e, { charCounterMax: maxChar, events: { "image.beforeUpload": function (e) { if (w.editor = this, e.length) { let t = e[0], o = new FormData(); if (Swal && typeof Swal.showLoading === "function") { Swal.showLoading(); } o.append("photo", t); fetch(w.FROALA_BASE_LINK + "froala/php/postfile.php", { method: "POST", body: o }).then(e => e.text()).then(e => { w.editor.image.insert(e, null, null, w.editor.image.get()); if (Swal && typeof Swal.showLoading === "function") { Swal.close(); } }) } return !1 }, "video.beforeUpload": function (e) { if (w.editor = this, e.length) { let t = e[0], o = new FormData(); if (Swal && typeof Swal.showLoading === "function") { Swal.showLoading(); }; o.append("photo", t); fetch(w.FROALA_BASE_LINK + "froala/php/postfile.php", { method: "POST", body: o }).then(e => e.text()).then(e => { w.editor.video.insert('<video src="' + e + '" style="width: 600px;" controls="" class="fr-draggable">Your browser does not support HTML5 video.</video>'); if (Swal && typeof Swal.showLoading === "function") { Swal.close(); } }) } return !1 } } })
            };
            w.onFroalaLoaded();
            setCrTextEditor(true);
            w.isFroalaLoaded = true;
            initRichBox();
            Swal.close();
            return;
          };
          let script = document.createElement("script");
          script.src = resources.data.js[index];
          index += 1;
          script.type = "text/javascript";
          head.appendChild(script);
          script.onload = onload;
        }
        let main = document.createElement("script");
        main.src = resources.data.js[index];
        main.type = "text/javascript";
        head.appendChild(main);
        index += 1;
        main.onload = onload;
      }
      if (w.isFroalaLoaded === true) {
        initRichBox();
      } else {
        GetFroala();
        w.onFroalaLoad = () => {
          initRichBox();
        }
      }
    } else {
      if (CrTextEditor === false) {
        setCrTextEditor(w.true);
      }
    }
  }, [])
  useEffect(() => {
    if (froala === null) {
      initRichBox();
    }
  }, [id, CrTextEditor])


  const initRichBox = () => {
    if (froala === null) {
      let w = window;
      if (id === "000") return;
      if (typeof (w.CreateTextEditor) === 'function') {
        const F = w.CreateTextEditor("#" + id, props.maxCharCount ?? 9999999);

        $(document).ready(() => {
          F.html.set(props.defaultValue ?? "")
          F.events.on("contentChanged", () => { onChange(F.html.get()) })
        })
        setFroala(F);
        w.f = F;
      }
    }
  }

  const onChange = (contents) => {

    if (!isNullOrUndefined(props.onChange)) props.onChange(contents);
    onChangeTxt(contents);
  };
  const onChangeTxt = (contents) => {

    if (!isNullOrUndefined(props.onChangeTxt))
      props.onChangeTxt(froala.getText());
  };

  /* const insertHtml = (data: any) => {
    froala.html.insert(data);
    //froala.insertHTML(data, true, true);
    props.onChange(froala.html.get());
  }; */

  return (
    <textarea id={id} name={props.name}>

    </textarea>
  );

}